import { Button, Grid, MenuItem, Stack, Typography } from "@mui/material";
import useOrderStore from "../../../stores/useOrderStore";
import update from "../../../api/auth/orders/reservations/update";
import { useForm } from "react-hook-form";
import WushTextField from "../WushTextField";
import useItemStore from "../../../stores/useItemStore";
import { useEffect, useState } from "react";
import getItems from "../../../api/auth/items/getItems";
import getItemCategories from "../../../api/auth/itemCategories/getItemCategories";
import ItemCategoryName from "../../text/ItemCategoryName";
import index from "../../../api/auth/itemCategories/bookableDurations";
import ReservationScheduler from "./ReservationScheduler";
import ReservationAvailability from "./ReservationAvailability";
import ReservationQuestionAnswers from "./ReservationQuestionAnswers";

export default function ReservationForm({ reservation }) {
  const [ selectedCategory, setSelectedCategory ] = useState(reservation.reservation_items[0]?.item?.item_category_id);
  const [ filteredItems, setFilteredItems ] = useState();
  const [ bookableDurations, setBookableDurations ] = useState();
  const [ selectedBookableDuration, setSelectedBookableDuration ] = useState(reservation.bookable_duration_id);

  const { items, setItems, setItemCategories, itemCategories } = useItemStore();
  const { updateReservation, updateOrder } = useOrderStore();

  const { register, handleSubmit, control, setValue, formState: { isDirty } } = useForm({
    defaultValues: {
      start_at: new Date()
    }
  });

  const onSubmit = (values) => {
    update(reservation.order_id, reservation.id, values, (response) => {
      updateReservation(response);
      updateOrder(response.order);
    }, (error) => {
      console.log(error);
    });
  };

  const handleSelectCategory = (categoryId) => {
    setSelectedCategory(categoryId);
    console.log(items);
    setFilteredItems(items.filter((item) => item.item_category_id === categoryId));
  };

  useEffect(() => {
    if(items.length === 0) {
      getItems((response) => {
        setItems(response);
      });
    }
    if(itemCategories.length === 0) {
      getItemCategories((response) => {
        setItemCategories(response);
      });
    }
    if(selectedCategory) {
      setFilteredItems(items.filter((item) => item.item_category_id === selectedCategory));
    }
  }, []);

  useEffect(() => {
    if(!selectedCategory) return;
      index(selectedCategory, (response) => {
        setBookableDurations(response);
      });
  }, [selectedCategory]);

  const enableSave = () => {
    return isDirty && selectedCategory && selectedBookableDuration;
  };

  // const handleItemQuantityIncrease = (itemId) => {
  //   setValue(`reservation_items[${itemId}][quantity]`, parseInt(getValues(`reservation_items[${itemId}][quantity]`), 10) + 1, { shouldDirty: true });
  //   if(enableHotUpdate) handleSubmit(onSubmit)();
  // };

  // const handleItemQuantityDecrease = (itemId) => {
  //   if(parseInt(getValues(`reservation_items[${itemId}][quantity]`), 10) > 0) {
  //     setValue(`reservation_items[${itemId}][quantity]`, parseInt(getValues(`reservation_items[${itemId}][quantity]`), 10) - 1, { shouldDirty: true });
  //     if(enableHotUpdate) handleSubmit(onSubmit)();
  //   }
  // };

  // const handleItemQuantityChange = () => {
  //   if(enableHotUpdate) handleSubmit(onSubmit)();
  // };

  return (
    <Stack>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Stack>
        </Stack>
        <Stack>
          <Stack p={2}>
            <Grid container spacing={4} mb={2}>
              <Grid item xs={12} sm={6}>
                <Stack>
                  <Typography variant="h6">Choose Items</Typography>
                </Stack>
                <Stack mb={2}>
                  <WushTextField
                    label="Select category"
                    formRegistration={{ onChange: (e) => handleSelectCategory(e.target.value)}}
                    defaultValue={selectedCategory}
                    select
                    disabled={reservation.reservation_items.length > 0}
                  >
                    {itemCategories.map((category) => (
                      <MenuItem key={category.id} value={category.id}>
                        <ItemCategoryName itemCategory={category} />
                      </MenuItem>
                    ))}
                  </WushTextField>
                </Stack>
                {selectedCategory && filteredItems &&
                  filteredItems.map((item) => (
                    <Grid key={item.id} container mb={1}>
                      <Grid item xs={12} sm={8}>
                        <Typography variant="h6">{item.name}</Typography>
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <WushTextField
                          sx={{ display: 'none' }}
                          formRegistration={register(`reservation_items[${item.id}][item_id]`)}
                          defaultValue={item.id}
                        />
                        <Stack direction="row">
                          <WushTextField
                            formRegistration={register(`reservation_items[${item.id}][quantity]`)}
                            defaultValue={reservation.reservation_items.filter((reservationItem) => reservationItem.item_id === item.id)[0]?.quantity || 0}
                            type="number"
                          />
                        </Stack>
                      </Grid>
                    </Grid>
                  ))
                }
              </Grid>
              {selectedCategory && bookableDurations && <Grid item xs={12} sm={6}>
                <Stack>
                  <Typography variant="h6">Date/Time</Typography>
                </Stack>
                <Stack>
                  <WushTextField
                    label="Booking option"
                    formRegistration={{ onChange: (e) => {
                      setValue('bookable_duration_id', e.target.value);
                      setSelectedBookableDuration(e.target.value);
                    }}}
                    defaultValue={reservation.bookable_duration_id}
                    select
                  >
                    {bookableDurations?.map((duration) => (
                      <MenuItem key={duration.id} value={duration.id}>
                        {duration.name}
                      </MenuItem>
                    ))}
                  </WushTextField>
                </Stack>
                {selectedBookableDuration && <Stack mt={2}>
                  <ReservationScheduler
                    setValue={setValue}
                    reservation={reservation}
                    bookableDuration={bookableDurations.filter((duration) => duration.id === selectedBookableDuration)[0]}
                    control={control}
                    register={register}
                  />
                </Stack>}
              </Grid>}
            </Grid>
            <Stack mb={2}>
              <ReservationAvailability reservation={reservation} />
            </Stack>
            <Stack mb={2}>
              <ReservationQuestionAnswers reservation={reservation} />
            </Stack>
            <Stack mb={2}>
              <WushTextField
                label="Admin comments"
                formRegistration={register('admin_comments')}
                defaultValue={reservation.admin_comments}
                multiline
              />
            </Stack>
            <Stack direction="row">
              <Button disabled={!enableSave()} type="submit" variant="contained">Save</Button>
            </Stack>
          </Stack>
        </Stack>
      </form>
    </Stack>
  );
}